<template>
	<b-modal
		class="modal-restore"
		:visible="show"
		@hide="() => this.$emit('close')"
		:title="headerText | translate"
		:ok-title="'Confirm' | translate"
		:cancel-title="'Cancel' | translate"
		@ok="() => $emit('restoreStudent')"
		:ok-disabled="isOkDisabled"
	>
		<slot />
	</b-modal>
</template>

<!-- 'Restore the student ?' -->

<script>
export default {
	name: 'modal-restore',
	props: ['show', 'restoreStudent', 'isOkDisabled', 'headerText'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.modal-restore {
	.modal-body {
		display: none;
	}

	.modal-footer {
		justify-content: space-between;
	}
}
</style>
